export function sendPageEvent() {
  // If the analytics was not loaded, we simply return
  if (window.digitalData?.events === undefined) return;

  const pageName = `tools${window.location.pathname}`;
  const dnow = Date.now();

  window.digitalData.events.push({
    event: {
      schema: "iglu:be.vrt/page_impression/jsonschema/1-1-0",
      data: {
        timestamp: dnow,
      },
    },
    context: [
      {
        schema: "iglu:be.vrt/context_page/jsonschema/1-2-1",
        data: {
          pagename: pageName,
          touchpointbrand: "vrt",
          contentbrand: "edubox",
          pageurl: window.location.href,
          pagetitle: "EDUbox Technologie: tool",
          domain: "www.vrt.be",
          pagepath: pageName,
          pagelanguage: "nl",
          sitesection1: "",
          sitesection2: "",
          sitesection3: "EDUbox Technologie",
          sitesection4: "",
          pageid: pageName,
        },
      },
    ],
  });
}
